import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { UpdateOrgProductFlagsRequest } from '@/definitions/productFlags'
import { UpdateOrgProductFlags } from '@/services/OrganizationService'

interface UpdateOrgProductFlagsVariables {
  orgId: string
  data: UpdateOrgProductFlagsRequest
}

export const useUpdateOrgProductFlags = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ orgId, data }: UpdateOrgProductFlagsVariables) =>
      UpdateOrgProductFlags(orgId, data),
    // The Product Flags tab reports a failure against the flags the operator was
    // editing, which a generic toast cannot do. Callers outside it should report the
    // error themselves.
    meta: { suppressGlobalError: true },
    onSuccess: (_organization, { orgId }) => {
      queryClient.invalidateQueries({ queryKey: ['organization', orgId] })
    },
  })
}
